import * as actionTypes from './actionTypes';
import admSvc from '../../axios-admsvc';
import {FETCH_AGENT_ACTIVITY_SEARCH_RESULT} from '../../shared/ApplicationUrls';

export const activitySearch = (searchCriteria) => {
    return (dispatch) => {
        dispatch(activityLogSpinner(true))
        admSvc.post(FETCH_AGENT_ACTIVITY_SEARCH_RESULT,searchCriteria)
            .then(response => {
                let searchResults = response.data.payload;
                if(response.data.status.code === "200" && response.data.payload.status !== "failure"){
                    dispatch(activitySearchSucess(searchResults));
                    dispatch(isActivitySearched(true));
                }else{
                    dispatch(activitySearchNotFoundErrorHandler());
                }
                dispatch(activityLogSpinner(false))
            })
            .catch(error => {
                // console.log("Agent activity fetch error ", error);
                if(error.toString().includes("404")){
                    dispatch(activitySearchNotFoundErrorHandler(error))
                }else{
                    dispatch(activitySearchException(error))
                }
                dispatch(activitySearchFailureResponse())
                dispatch(activityLogSpinner(false))
            }).then(res => {
                //to handle exception
            });
    }

}

export const setSearchState = (formData) => {
    return{
        type: actionTypes.ACTIVITY_LOG_SEARCH_STATE,
        response: formData
    }
}

export const setError = (error) => {
    return {
        type: actionTypes.SET_ERROR,
        error: error
    }
}

export const activitySearchSucess = (data) => {
    return {
        type : actionTypes.SEARCH_ACTIVITY_LOG,
        response: data
    }
}

export const activitySearchFailureResponse = () => {
    return {
        type : actionTypes.SEARCH_ACTIVITY_LOG,
        response: {}
    }
}

export const activitySearchException = (error) => {
    return {
        type : actionTypes.SEARCH_ACTIVITY_FAILURE,
        error: error
    }
}

export const activitySearchNotFoundErrorHandler = (error) => {
    return {
        type : actionTypes.SEARCH_ACTIVITY_NOT_FOUND,
        error: error
    }
}

export const activitySearchSetPageNumber = (pageNumber) => {
    return{
        type: actionTypes.ACTIVITY_LOG_PAGE_NUMBER,
        response: pageNumber
    }
}

export const isActivitySearched = (boolValue) => {
    return {
        type: actionTypes.IS_ACTIVITY_SEARCHED,
        response: boolValue
    }
}

export const activityLogSelectEvent = (value) => {
    return{
        type: actionTypes.SELECT_EVENT_ACTIVITY_LOG,
        response: value
    }
}

export const activityLogUserIdEvent = (value) => {
    return{
        type: actionTypes.ACTIVITY_LOG_USERID,
        response: value
    }
}

export const activityLogSpinner = (showSpinner) => {
    return{
        type: actionTypes.ACTIVITY_LOG_SPINNER,
        response: showSpinner
    }
}